import React, { createContext, useContext, useEffect, useState } from 'react';

const LangContext = createContext(null);

const STORAGE_KEY = 'axaca_lang';

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === 'undefined') return 'fr';
    return window.localStorage.getItem(STORAGE_KEY) || 'fr';
  });

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.setAttribute('lang', lang);
  }, [lang]);

  const setLang = (next) => {
    if (next === 'fr' || next === 'en') setLangState(next);
  };

  return (
    <LangContext.Provider value={{ lang, setLang }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) {
    throw new Error('useLang must be used inside <LangProvider>');
  }
  return ctx;
};
